import React from 'react';
import CardGranularStep from '../GSCard';
import LcElemensCards from '../../LcElemensCards';
import CurriculumElementsCards from '../../CurriculumElementsCards';
import ScrollToBottom from 'react-scroll-to-bottom';

const LGColumn = ({
  lcs = [],
  completed,
  currentCurriculum,
  learningGrowth = [],
  loadingLearningGrowth,
  classUlInfo,
  top = '0px'
}) => {
  const minMarking = currentCurriculum?.marking?.find((item) => item.minValue) || {};
  const maxMarking = currentCurriculum?.marking?.find((item) => item.maxValue) || {};

  const lcsElements = {};
  let levelsId = [];
  lcs.forEach((lc) => {
    lcsElements[lc._id] = currentCurriculum.elements;
    const lvls = lc.granularSteps?.filter((step) => step.definition).map((step) => step.levelId);
    levelsId = [...levelsId, ...lvls];
  });

  levelsId = [...new Set(levelsId)];
  const levelsRender = currentCurriculum?.levels
    ?.filter((item) => levelsId.includes(item._id))
    .sort((a, b) => b.position - a.position);
  const size = 35;

  return (
    <ScrollToBottom className='w-full h-full' followButtonClassName='z-20'>
      <div className={['py-1 flex flex-col gap-1', lcs.length > 3 ? 'w-fit' : 'w-auto'].join(' ')}>
        {levelsRender?.map((item, index) => (
          <React.Fragment key={`granular-steps-level-${item._id}-${index}`}>
            <CardGranularStep
              completed={completed}
              lcs={lcs}
              levelId={item._id}
              level={{
                ...item,
                primaryColor: minMarking?.primaryColor,
                secondaryColor: minMarking?.secondaryColor,
                levelIndex: index
              }}
              nextLevel={levelsRender[index - 1]}
              marking={currentCurriculum.marking || []}
              minMarking={minMarking}
              maxMarking={maxMarking}
              learningGrowth={learningGrowth}
              loadingLearningGrowth={loadingLearningGrowth}
              currentCurriculum={currentCurriculum}
              size={size}
              direction='column'
              top={top}
            />
          </React.Fragment>
        ))}
        <LcElemensCards
          currentCurriculum={currentCurriculum}
          classUlInfo={classUlInfo}
          lcs={lcs || []}
          width='min-w-100px max-w-100px'
          top={top}
        />
        <CurriculumElementsCards
          currentCurriculum={currentCurriculum}
          lcs={lcs || []}
          width='min-w-100px max-w-100px'
          classUlInfo={classUlInfo}
          top={top}
        />
      </div>
    </ScrollToBottom>
  );
};

export default LGColumn;
